module.exports = __webpack_public_path__ + "img/image-6.a0ba550a.webp";